import React, { useContext } from 'react';
import { Box } from '@material-ui/core';

import { LandingContext } from '../../../../context/landing';
import { CLIENTS_INVESTORS_SECTION } from '../../../../constants';
import { BoxRounded } from '../../../../components/BoxRounded';
import { CarouselSlider } from '../../../../components/CarouselSlider';
import useStyles from './useStyles';

export const ClientsInvestorsSection = () => {
  const classes = useStyles();
  const { landingData } = useContext(LandingContext);
  const dataClientsInvestors = landingData[CLIENTS_INVESTORS_SECTION] || {};
  const {
    show = false, title = '', images = [], carouselConfig = {},
  } = dataClientsInvestors;

  if (!show) return null;

  return (
    <Box component="section" className={classes.sectionContainer}>
      <BoxRounded
        title={title}
      >
        <CarouselSlider
          images={images}
          carouselConfig={carouselConfig}
          classNames={{
            img: classes.img,
            imgContainer: classes.imgContainer,
          }}
        />
      </BoxRounded>
    </Box>
  );
};
